import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogClose, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {TranslateModule} from "@ngx-translate/core";
import {MatCheckbox} from "@angular/material/checkbox";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {LOV} from "../../../core/models/listOfValue.model";
import {AppUrlConstants} from "../../../core/constants/AppUrlConstants";
import {GenericCrudService} from "../../../core/services/generic-crud.service";
import {ApplicationDataService} from "../../../core/services/application-data.service";
import {Tehsil} from "../../../core/models/tehsil.model";
import {AlertDialogComponent} from "../../../shared/alert-dialog/alert-dialog.component";

@Component({
  selector: 'app-add-edit-tehsil',
  standalone: true,
  imports: [MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule,
    ReactiveFormsModule, MatDialogClose, TranslateModule, MatCheckbox, MatOption, MatSelect],
  templateUrl: './add-edit-tehsil.component.html'
})
export class AddEditTehsilComponent implements OnInit{
  divisionList: LOV[] = [];
  districtList: LOV[] = [];
  districtsIds: number;
  divisionsIds: number;
  filteredListDivision: any[] = [];
  filteredListDistrict: any[] = [];
  segmentType:string = "NONE";
  form: FormGroup;
  constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<AddEditTehsilComponent>,
      public dialog: MatDialog, private formBuilder: FormBuilder,
      private crudService: GenericCrudService,
      private appDataService: ApplicationDataService) {
  }
  ngOnInit() {
    this.form = this.formBuilder.group({
      adminStrId: [null],
      division: ['', [Validators.required]],
      district: ['', [Validators.required]],
      name: ['', [Validators.required, Validators.maxLength(60)]],
      description: ['', [Validators.required, Validators.maxLength(300),]],
      parentAdminStrId: [],
      divisionsIds: [],
      districtsIds: [],
      pulse: [false],
      plra: [false],
      segmentType:[],
      adminStructureTypes: "TEHSIL"
    });

    this.getDivisionList();
    this.onValueChangeDivision();
    if(this.data != null) {
      this.updateSegment(this.data);
      
      // Set the known values immediately
      this.form.patchValue({
        adminStrId: this.data.adminStrId,
        name: this.data.name,
        description: this.data.description,
        parentAdminStrId: this.data.parentAdminStrId,
        pulse: this.data.pulse,
        plra: this.data.plra
      });
      
      // Get the district details - use a different endpoint
      this.appDataService.getByType("DISTRICT").subscribe({
        next: (allDistricts: any) => {
          if (allDistricts && allDistricts.data) {
            // Find our district
            const district = allDistricts.data.find((d: any) => 
              d.adminStrId === this.data.parentAdminStrId
            );
            
            if (district) {
              // Now we know the division
              this.form.patchValue({
                division: district.parentAdminStrId
              });
              
              // Wait for division change to trigger district loading
              setTimeout(() => {
                this.form.patchValue({
                  district: this.data.parentAdminStrId
                });
              }, 10);
            }
          }
        },
        error: (e) => {
          console.error("Error fetching districts:", e);
        }
      });
    }
  }
  onValueChangeDivision() {
    this.form.controls['division'].valueChanges.subscribe({
      next: (data: any) => {
        // Reset the district when division changes
        this.form.controls['district'].setValue('');
        
        // Mark the district field as touched to trigger validation display
        this.form.controls['district'].markAsTouched();
        
        // Load districts for the new division
        this.getDistrictByDivisions(data);
      }
    })
  }
  getDivisionList(){
    this.appDataService.getByType("DIVISION").subscribe({
      next: (res: any) => {
        res.data.forEach((item:any) => {
          this.divisionList.push(item);
           // Initialize filtered list for Division
          this.filteredListDivision = this.onFilteredListSearch(null, this.divisionList, 'name');
        });
      }
    });
  }
  getDistrictByDivisions(id: any){
    this.districtList = [];
    this.appDataService.getAdmStructurebyParentId(id).subscribe({
      next: (res: any) => {
        res.data.forEach((item:any) => {
          this.districtList.push(item);
           // Initialize filtered list for District
        this.filteredListDistrict = this.onFilteredListSearch(null, this.districtList, 'name');
        });
      }
    });
  }
  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }
  add() {
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.district});
    //console.log(this.form.value);
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.ADD).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message);
          }
        }
      }
    });
  }
  edit() {
    // Remove debugger statement
    this.setSegment(this.form.value);
    this.form.patchValue({segmentType: this.segmentType});
    this.form.patchValue({parentAdminStrId: this.form.value.district});
    
    // Log the complete form value for debugging
    console.log("Form data being sent:", JSON.stringify(this.form.value));
    
    this.crudService.add(this.form.value, AppUrlConstants.ADMINISTRATIVE_STRUCTURE_URL + AppUrlConstants.EDIT).subscribe({
      next: (res: any) => {
        this.dialogRef.close(res?.data);
      },
      error: (e) => {
        console.error("Edit error:", e);
        if (e?.status == 409) {
          if (e?.error?.errors !== null) {
            for (const property in e.error.errors) {
              this.openAlert(e.error.errors[property]);
            }
          } else {
            this.openAlert(e?.error?.message || "Unknown conflict error");
          }
        } else {
          this.openAlert(`Error ${e.status}: ${e.error?.message || "Unknown error"}`);
        }
      }
    });
  }
  setSegment(result: any){
    if (result.pulse && result.plra) {
      this.segmentType = 'ALL';
    } else if (!result.pulse && !result.plra) {
      this.segmentType = 'NONE';
    } else {
      this.segmentType = result.pulse ? 'PULSE' : 'PLRA';
    }
  }
  updateSegment(updateRecord: Tehsil){
    switch (updateRecord.segmentType) {
      case 'ALL':
        updateRecord.pulse = true;
        updateRecord.plra = true;
        break;
      case 'NONE':
        updateRecord.pulse = false;
        updateRecord.plra = false;
        break;
      case 'PULSE':
        updateRecord.pulse = true;
        updateRecord.plra = false;
        break;
      case 'PLRA':
        updateRecord.pulse = false;
        updateRecord.plra = true;
        break;
      default:
        // Handle any other cases if needed
        break;
    }
  }
  openAlert(message: string) {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: {
        message: message,
        buttonText: {
          cancel: 'OK'
        }
      },
    });
  }
  onFilteredListSearch(event: any, originalList: any[], property: string): any[] {
    let filteredList: any[];
    if (event && event.target.value) {
      filteredList = originalList.filter(item => item[property].toLowerCase().includes(event.target.value.toLowerCase()));
    } else {
      filteredList = originalList; // Copy the original list
    }
    return filteredList;
  }

  onOptionSelected(event: any, formControlName: string) {
  
    const searchInput = document.getElementById('search-select') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
    // Reset the filtered list to the original list
    if (formControlName === 'division') {
      this.filteredListDivision = this.divisionList;
    };

    if (formControlName === 'district') {
      this.filteredListDistrict = this.districtList;
    };
  }
}
